import { useState } from "react"

import InputText from "../InputText"

import "./style.css"

import icon_close from './../../assets/svg/svg_close_contact.svg'
import icon_email from './../../assets/svg/svg_email.svg'
import icon_phone from './../../assets/svg/svg_phone.svg'
import icon_linkedin from './../../assets/svg/svg_linkedin.svg'
import icon_twitter from './../../assets/svg/svg_twitter.svg'
import icon_facebook from './../../assets/svg/svg_facebook.svg'


const init_form = {
    lastname: '',
    firstname: '',
    email: '',
    phone: '',
    company: '',
    user_id: '',
    request: ''
}


function Contact({ setShowMdlContact }) {
    const [formContact, setFormContact] = useState(init_form);

    const setTextarea = (e) => {
        const newValue = e.target.value.replace(/[<>{}]/g, '');
        setFormContact(prev => ({ ...prev, request: newValue }));
    }

    return (
        <div className="modal mdl_contact">
            <button
                className='hover_close_mdl'
                onClick={() => setShowMdlContact(false)}
            ></button>

            <div className="content">
                <div className="contact">
                    <span>Nous contacter</span>
                    <p>Appelez-nous ou remplissez le formulaire ci-dessous et nous vous contacterons. <br />
                    <br />Nous nous efforçons de répondre à toutes les demandes dans les 24 heures les jours ouvrables.</p>

                    <div className="email_phone">
                        <button>
                            <img src={icon_email} alt=" " />
                            <p>contact@corentin-beaudet.fr</p>
                        </button>

                        <button>
                            <img src={icon_phone} alt=" " />
                            <p>+33 7 74 69 84 15</p>
                        </button>
                    </div>

                    <div className="social">
                        <button><img src={icon_linkedin} alt=" " /></button>
                        <button><img src={icon_twitter} alt=" " /></button>
                        <button><img src={icon_facebook} alt=" " /></button>
                    </div>
                </div>

                <form>
                    <button
                        type='button'
                        className='btn_close'
                        onClick={() => setShowMdlContact(false)}
                    ><img src={icon_close} alt=" " /></button>

                    <div className="grid">
                        <InputText label='Nom :' placeholder='Snow' value={formContact.lastname} setValue={setFormContact} field='lastname' />
                        <InputText label='Prénom :' placeholder='John' value={formContact.firstname} setValue={setFormContact} field='firstname' />

                        <InputText label='Adresse mail :' placeholder='john.snow@hotmail.fr' value={formContact.email} setValue={setFormContact} field='email' />
                        <InputText label='Téléphone :' placeholder='06 70 18 80 19' value={formContact.phone} setValue={setFormContact} field='phone' />

                        <InputText label='Entreprise : *' placeholder='webSpace' value={formContact.company} setValue={setFormContact} field='company' />
                        <InputText label='Id client : *' placeholder='webSpace402' value={formContact.user_id} setValue={setFormContact} field='user_id' />
                    </div>

                    <div className="input_textarea">
                        <label>Demande :</label>

                        <textarea
                            type="text"
                            placeholder='Comment pouvons nous vous aider ?'

                            value={formContact.request}
                            onChange={e => setTextarea(e)}
                        />
                    </div>

                    <span>* optionnel</span>

                    <button
                        type="submit"
                        className='btn_submit'
                    >Confirmer</button>
                </form>
            </div>
        </div>
    )
}

export default Contact;